import React from 'react'
import Tr from 'translations/Translations';
import EventIcon from '@material-ui/icons/Event'
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconCalendarButton(
    {
        tooltip = Tr('choose_date'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={EventIcon}
        {...props}
    />
}

WorkableIconCalendarButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconCalendarButton;